const prosperIconsUrl = '/production/prosper/app/icon';
const pegasusIconsUrl = '/production/static/images';
const prosperImages = '/production/prosper/images';
const clinkProjectUrl = '/production/static/images/project';
const prosperContractor = '/production/contractor/images';
const prosperSuccess = '/production/prosper/app/feature/success-stories';
const clinkApp = '/production/c-link/app';
const clinkImages = '/production/c-link/images';

module.exports = {
  requestIcon: `${clinkApp}/request-icon.svg`,
  iconCloseGray: `${clinkApp}/icon-close-gray.svg`,
  viewProfileCarousel: `${clinkApp}/view-profile-carousel.svg`,
  iconEditTurqoise: `${clinkApp}/icon-edit-turqoise.svg`,
  iconExclamationTriangleRed: `${clinkApp}/icon-exclamation-triangle-red.svg`,
  iconRoundAwardedLigthgreen: `${clinkApp}/icon-round-awarded-ligthgreen.svg`,
  iconRoundEditLigthgreen: `${clinkApp}/icon-round-edit-ligthgreen.svg`,
  iconRoundOnsiteLigthgreen: `${clinkApp}/icon-round-onsite-ligthgreen.svg`,
  iconRoundQuotedLigthgreen: `${clinkApp}/icon-round-quoted-ligthgreen.svg`,
  iconRoundTenderLigthgreen: `${clinkApp}/icon-round-tender-ligthgreen.svg`,
  iconLinkBlack: `${clinkApp}/icon-link-black.svg`,
  calendarGreen: `${prosperIconsUrl}/icon-calendar-green.svg`,
  svgLightpurpleQuotes: `${prosperIconsUrl}/icon-lightpurple-quotes.svg`,
  svgPurpleQuotes: `${prosperIconsUrl}/icon-purple-quotes.svg`,
  pngLightpurpleQuotes: `${prosperIconsUrl}/icon-lightpurple-quotes.png`,
  pngPurpleQuotes: `${prosperIconsUrl}/icon-purple-quotes.png`,
  sosNext: `${prosperIconsUrl}/icon-sos-netext.svg`,
  tenderReturnTemplate: `${prosperIconsUrl}/tender-return-template.svg`,
  luke: `${prosperIconsUrl}/luke.svg`,
  armConcepts: `${prosperSuccess}/arm-concepts_Ezio%20Muratore.jpeg`,
  benmax: `${prosperSuccess}/Benmax_Doug%20Benmax.jpeg`,
  dorplan: `${prosperSuccess}/DORPLAN_Russell%20Evershed.jpeg`,
  GKDrywall: `${prosperSuccess}/GK%20Drywall_Kieren%20Tree.png`,
  SLE: `${prosperSuccess}/SLE%20Elec_Jeremy%20Wood.png`,
  baseUFH: `${prosperSuccess}/BaseUFH_Shane+cox.jpeg`,
  LBC: `${prosperSuccess}/LBC_Luke%20Banfield.webp`,
  vepcons: `${prosperSuccess}/vepcons_Eugen%20Panciuc.jpeg`,
  weatherfix: `${prosperSuccess}/Weatherfix-Oliver%20Sweeney.jpeg`,
  iconTokenEmptyBig: `${prosperIconsUrl}/icon-token-empty-big.svg`,
  iconTokenEmptySmall: `${prosperIconsUrl}/icon-token-empty-small.svg`,
  iconTokenSmall: `${prosperIconsUrl}/icon-token-small.svg`,
  iconClinkLogo: `${pegasusIconsUrl}/icon-clink-logo.svg`,
  uploadSvg: `${pegasusIconsUrl}/icon-upload.svg`,
  uploadingSvg: `${pegasusIconsUrl}/icon-uploading.svg`,
  uploadFailedSvg: `${pegasusIconsUrl}/icon-upload-failed.svg`,
  iconRoundCheckGreen: `${pegasusIconsUrl}/icon-round-check-green.svg`,
  iconRoundCheckRedInverted: `${pegasusIconsUrl}/icon-round-check-red-inverted.svg`,
  iconRoundCheckRed: `${pegasusIconsUrl}/icon-round-check-red.svg`,
  chatCloseSvg: `${prosperIconsUrl}/chat-close.svg`,
  attachSvg: `${prosperIconsUrl}/chat-attach.svg`,
  boldSvg: `${prosperIconsUrl}/chat-bold.svg`,
  italicSvg: `${prosperIconsUrl}/chat-italic.svg`,
  orderedSvg: `${prosperIconsUrl}/chat-ordered.svg`,
  underlineSvg: `${prosperIconsUrl}/chat-underline.svg`,
  unorderedSvg: `${prosperIconsUrl}/chat-unordered.svg`,
  pegasusBlackLogo: '/pegasus-black.svg',
  closeButtonActive: `${pegasusIconsUrl}/icon-close-red.svg`,
  closeButtonDisabled: `${pegasusIconsUrl}/icon-close-white.svg`,
  caretDownWhite: `${prosperIconsUrl}/caret-down-white.png`,
  carretDown: '/carret-down.svg',
  carretUp: '/carret-up.svg',
  clinkImage: '/clink-notext-logo.svg',
  prosperImage: '/prosper-notext-logo.svg',
  pegasusLogo: '/pegasus-logo.png',
  hatLogo: '/hat.svg',
  clinkLogo: '/clink-logo.png',
  locationLogo: `${prosperIconsUrl}/icon-location.svg`,
  infoLogo: `${prosperIconsUrl}/icon-info.svg`,
  infoLogoBlack: `${prosperIconsUrl}/icon-info-black.svg`,
  infoLogoGray: `${prosperIconsUrl}/icon-info-gray.svg`,
  rocketLogo: `${prosperIconsUrl}/icon-rocket.svg`,
  calendarLogo: `${prosperIconsUrl}/icon-calendar.svg`,
  statusLogo: `${prosperIconsUrl}/icon-status.svg`,
  closedIcon: `${prosperIconsUrl}/icon-closed.svg`,
  iconMessage: `${prosperIconsUrl}/icon-message.svg`,
  redCaretLeft: `${prosperIconsUrl}/icon-red-arrow-left.svg`,
  redCaretRight: `${prosperIconsUrl}/icon-red-arrow-right.svg`,
  redCaretUp: `${prosperIconsUrl}/caret-up-red.svg`,
  redCaretDown: `${prosperIconsUrl}/carret-down-red.svg`,
  iconDownloadBlack: `${prosperIconsUrl}/icon-download-black.svg`,
  iconMessageBlack: `${prosperIconsUrl}/icon-message-black.svg`,
  iconOrganiseBlack: `${prosperIconsUrl}/icon-organise-black.svg`,
  iconQuoteBlack: `${prosperIconsUrl}/icon-quote-black.svg`,
  prosperPackagesDefault: `${prosperImages}/project-default.jpg`,
  specialistLogo: `${prosperImages}/specialist-logo.png`,

  poundWhite: `${prosperIconsUrl}/icon-pound-white.svg`,
  addGray: `${prosperIconsUrl}/icon-add-gray.svg`,
  blackCarretRight: `${prosperIconsUrl}/icon-caret-black-right.svg`,
  upload: `${prosperIconsUrl}/icon-upload.svg`,
  blackCarretLeft: `${prosperIconsUrl}/icon-caret-black-left.svg`,
  infoLogoRed: `${prosperIconsUrl}/icon-danger-red.svg`,
  pngIconGreen: `${prosperIconsUrl}/icon-png-green.svg`,
  prosperLogoFull: `${prosperImages}/prosper-logo.svg`,
  deleteIconRed: `${prosperIconsUrl}/icon-delete-red.svg`,
  iconContractor: `${prosperContractor}/default-icon.png`,
  checkmarkGreen: `${prosperIconsUrl}/icon-check-green.svg`,
  iconSearchGreen: `${prosperIconsUrl}/icon-search-green.svg`,
  alcumus: `${prosperImages}/alcumus.svg`,
  chas: `${prosperImages}/chas.svg`,
  considerate: `${prosperImages}/considerate.svg`,
  constructiOnline: `${prosperImages}/constructi-online.svg`,
  iconConversationGray: `${prosperIconsUrl}/icon-conversation-gray.svg`,
  iconSearchBlack: `${prosperIconsUrl}/icon-search-black.svg`,
  iconAddWhite: `${prosperIconsUrl}/icon-add-white.svg`,
  iconCloseRed: `${prosperIconsUrl}/icon-close-red.svg`,
  iconHamburgerWhite: `${prosperIconsUrl}/icon-hamburger-white.svg`,
  iconPdfBlack: `${prosperIconsUrl}/icon-pdf-black.svg`,
  iso14001: `${prosperImages}/iso14001.svg`,
  iso9001: `${prosperImages}/iso9001.svg`,
  ohas18001: `${prosperImages}/ohas18001.svg`,
  smas: `${prosperImages}/smas.svg`,

  instructions: `${clinkProjectUrl}/instructions-icon.svg`,
  ncr: `${clinkProjectUrl}/ncr-icon.svg`,
  pmp: `${clinkProjectUrl}/pmp-icon.svg`,
  project: `${clinkProjectUrl}/project-icon.svg`,
  carretDownGray: `${clinkProjectUrl}/caret-down-gray-icon.svg`,
  expand: `${clinkProjectUrl}/expand-icon.svg`,
  tools: `${clinkProjectUrl}/tools-icon.svg`,
  forecast: `${clinkProjectUrl}/forecast-icon.svg`,

  // clink app
  forecastPurple: `${clinkApp}/icon-forecast-purple.svg`,
  instructionsPurple: `${clinkApp}/icon-instructions-purple.svg`,
  pmpPurple: `${clinkApp}/icon-plan-purple.svg`,
  projectPurple: `${clinkApp}/icon-project-purple.svg`,
  toolsPurple: `${clinkApp}/icon-tools-purple.svg`,
  ncrPurple: `${clinkApp}/icon-ncr-purple.svg`,
  marker: `${clinkApp}/marker.svg`,
  markerWarning: `${clinkApp}/markerWarning.svg`,
  iconReturnBlack: `${clinkApp}/icon-return-black.svg`,
  iconRecommendedOrange: `${clinkApp}/icon-recommended-orange.svg`,
  iconXBlack: `${clinkApp}/iconXBlack.svg`,
  iconTrashBlack: `${clinkApp}/iconTrashBlack.svg`,
  dateLine: `${clinkApp}/date-line.svg`,
  alertLine: `${clinkApp}/alert-line.svg`,

  // clink app package management
  iconDecisionCalendarPink: `${clinkApp}/icon-decision-calendar-pink.svg`,
  iconDownArrowGrey: `${clinkApp}/icon-down-arrow-grey.svg`,
  iconCloseButtonCrossGrey: `${clinkApp}/icon-close-button-cross-grey.svg`,
  iconDecisionCalendarGrey: `${clinkApp}/icon-calendar-icon-grey.svg`,
  iconAwardedGrey: `${clinkApp}/icon-awarded-mobile-icon.svg`,

  // clink images
  excelBlack: `${clinkImages}/icon-excel-black.svg`,
  pdfBlack: `${clinkImages}/icon-pdf-black.svg`,

  // clink - prosper profile
  constructionLogo: `${clinkImages}/construction-logo.svg`,
  iconDownloadWhite: `${clinkImages}/icon-download-white.svg`,
  iconPersonWhite: `${clinkImages}/icon-person-white.svg`,
  iconAssuranceGray: `${clinkImages}/icon-insurance-gray.svg`,

  // clink - prosper profile - tabs
  iconAccreditationsGray: `${clinkImages}/icon-accreditations-gray.svg`,
  iconAccreditationsGreen: `${clinkImages}/icon-accreditations-green.svg`,
  iconIncusrancesGray: `${clinkImages}/icon-incusrances-gray.svg`,
  iconIncusrancesGreen: `${clinkImages}/icon-incusrances-green.svg`,
  iconLocationsGray: `${clinkImages}/icon-locations-gray.svg`,
  iconLocationsGreen: `${clinkImages}/icon-locations-green.svg`,
  iconManagementGray: `${clinkImages}/icon-management-gray.svg`,
  iconManagementGreen: `${clinkImages}/icon-management-green.svg`,
  iconProjectGray: `${clinkImages}/icon-project-gray.svg`,
  iconProjectGreen: `${clinkImages}/icon-project-green.svg`,
  iconReferencesGray: `${clinkImages}/icon-references-gray.svg`,
  iconReferencesGreen: `${clinkImages}/icon-references-green.svg`,
  iconTradesGray: `${clinkImages}/icon-trades-gray.svg`,
  iconTradesGreen: `${clinkImages}/icon-trades-green.svg`,
  iconTurnoverGray: `${clinkImages}/icon-turnover-gray.svg`,
  iconTurnoverGreen: `${clinkImages}/icon-turnover-green.svg`,
  iconApprovedGreen: `${clinkApp}/icon-approved-green.svg`,
  iconProvidedTeal: `${clinkApp}/icon-provided-teal.svg`,
  iconNotProvidedRed: `${clinkImages}/icon_patch_not_provided.svg`,
  iconPoundGreen: `${clinkApp}/icon-pound-green.svg`,
  iconDownloadGray: `${clinkApp}/icon-download-gray.svg`,

  // prosper dashboard empty feed
  iconArrowdownLightblue: `${prosperImages}/icon-arrowdown-lightblue.svg`,
  iconBuildingLightblue: `${prosperImages}/icon-building-lightblue.svg`,
  iconChatLightblue: `${prosperImages}/icon-chat-lightblue.svg`,
  iconListLightblue: `${prosperImages}/icon-list-lightblue.svg`,
  // Prosper Success
  logoChecked: `${prosperImages}/logo-checked.svg`,
  logoStripe: `${prosperImages}/logo-stripe.svg`,
  // Prosper Background
  backgroundShapesInternal: `${prosperImages}/background-shapes-internal.svg`,

  // Prosper Status Icons
  iconBlackAccept: `${prosperIconsUrl}/icon-black-accept.svg`,
  iconBlackInterest: `${prosperIconsUrl}/icon-black-interest.svg`,
  iconBlackQuote: `${prosperIconsUrl}/icon-black-quote.svg`,
  iconBlackTender: `${prosperIconsUrl}/icon-black-tender.svg`,
  iconBlackTrophy: `${prosperIconsUrl}/icon-black-trophy.svg`,
  iconWhiteAccept: `${prosperIconsUrl}/icon-white-accept.svg`,
  iconWhiteInterest: `${prosperIconsUrl}/icon-white-interest.svg`,
  iconWhiteQuote: `${prosperIconsUrl}/icon-white-quote.svg`,
  iconWhiteTender: `${prosperIconsUrl}/icon-white-tender.svg`,
  iconWhiteTrophy: `${prosperIconsUrl}/icon-white-trophy.svg`,
  iconRedDanger: `${prosperIconsUrl}/icon-red-danger.svg`,
  iconRedAward: `${prosperIconsUrl}/icon-red-award.svg`,

  // Prosper Company Profile Icons
  iconPurpleDoc: `${prosperIconsUrl}/icon-purple-doc.svg`,
  iconPurpleWebsite: `${prosperIconsUrl}/icon-purple-website.svg`,
  iconPurplePhone: `${prosperIconsUrl}/icon-purple-phone.svg`,
  iconPurpleMail: `${prosperIconsUrl}/icon-purple-mail.svg`,
  iconPurpleLocation: `${prosperIconsUrl}/icon-purple-location.svg`,
  iconPurpleLinkedin: `${prosperIconsUrl}/icon-purple-linkedin.svg`,

  // Prosper Interests Revamp
  iconOrangeCalendar: `${prosperIconsUrl}/icon-orange-calendar.svg`,
  iconOrangePound: `${prosperIconsUrl}/icon-orange-pound.svg`,
  iconOrangeStart: `${prosperIconsUrl}/icon-orange-start.svg`,
  iconOrangeType: `${prosperIconsUrl}/icon-orange-type.svg`,
  iconRedClock: `${prosperIconsUrl}/icon-red-clock.svg`,
  iconWhiteLock: `${prosperIconsUrl}/icon-white-lock.svg`,
  registeredInterestIcon: `${prosperIconsUrl}/registered-interest-icon.svg`,
  distancePink: `${prosperIconsUrl}/distance-pink.svg`,
  distancePurple: `${prosperIconsUrl}/distance-purple.svg`,

  // Prosper Pro Banner Footer
  iconPartyHorn: `${prosperIconsUrl}/icon-party-horn.svg`,
  iconWhiteBell: `${prosperIconsUrl}/icon-white-bell.svg`,
  iconWhiteClock: `${prosperIconsUrl}/icon-white-clock.svg`,
  iconThumbnailBuildingsDesktop: `${prosperIconsUrl}/thumbnail-buildings-desktop.svg`,
  iconThumbnailBuildingsMobile: `${prosperIconsUrl}/thumbnail-buildings-mobile.svg`,
  iconThumbnailBuildingsDesktopSp: `${prosperIconsUrl}/thumbnail-buildings-sp-desktop.svg`,
  iconThumbnailWorkers: `${prosperIconsUrl}/thumbnail-workers.svg`,
  closeButton: `${prosperIconsUrl}/Close-button.svg`,
  freeTokenAwarded: `${prosperImages}/Free-token-awarded.svg`,
  freeTokenAwardedBlank: `${prosperImages}/Free-token-awarded-blank.svg`,

  // Prosper How To Work
  iconHowToWork: `${prosperIconsUrl}/how_to_win_work.png`,

  // Prosper Preq v2
  iconReuseBlack: `${prosperIconsUrl}/icon-reuse-black.svg`,
  iconTargetBlack: `${prosperIconsUrl}/icon-target-black.svg`,
  iconRoundPoundBlack: `${prosperIconsUrl}/icon-round-pound-black.svg`,
  iconBlackBin: `${prosperIconsUrl}/icon-bin-black.svg`,
  iconApprovedWhite: `${prosperIconsUrl}/icon-approved-white.svg`,
  iconCalendarBlack: `${prosperIconsUrl}/icon-calendar-black.svg`,
  iconCasketBlack: `${prosperIconsUrl}/icon-casket-black.svg`,
  iconCertificateGray: `${prosperIconsUrl}/icon-certificate-gray.svg`,
  iconEnvelopeBlack: `${prosperIconsUrl}/icon-envelope-black.svg`,
  iconEyeBlack: `${prosperIconsUrl}/icon-eye-black.svg`,
  iconFacebookBlack: `${prosperIconsUrl}/icon-facebook-black.svg`,
  iconCloseWhite: `${prosperIconsUrl}/icon-close-white.svg`,
  iconHammerBlack: `${prosperIconsUrl}/icon-hammer-black.svg`,
  iconInsuranceDarkgray: `${prosperIconsUrl}/icon-insurance-darkgray.svg`,
  iconPendingWhite: `${prosperIconsUrl}/icon-pending-white.svg`,
  iconQuestionBlack: `${prosperIconsUrl}/icon-question-black.svg`,
  iconRejectedWhite: `${prosperIconsUrl}/icon-rejected-white.svg`,
  iconRulerBlack: `${prosperIconsUrl}/icon-ruler-black.svg`,
  iconSckrewBlack: `${prosperIconsUrl}/icon-sckrew-black.svg`,
  iconShareFillBlack: `${prosperIconsUrl}/icon-share-fill-black.svg`,
  iconThreeDotsBlack: `${prosperIconsUrl}/icon-three-dots-balck.svg`,
  iconWhatsappBlack: `${prosperIconsUrl}/icon-whatsapp-black.svg`,

  // clink BOQ
  boqScratch: `${clinkApp}/boq.png`,

  // Prosper Preq PQQ new documents
  // Enviromental, Quality, Management System Procedures
  isoLogoRegisteredTrademarkOG: `${prosperIconsUrl}/iso-logo-registered-trademark.gif`,
  isoLogoRegisteredTrademark: `${prosperIconsUrl}/iso-logo-registered-trademark.svg`,
  // Enviromental
  fscLogoOG: `${prosperIconsUrl}/fsc-logo.jpg`,
  fscLogo: `${prosperIconsUrl}/fsc-logo.svg`,
  // Health, Safety & Environmental Qualifications
  ioshLogoOG: `${prosperIconsUrl}/iosh-logo.png`,
  ioshLogo: `${prosperIconsUrl}/iosh-logo.svg`,
  neboshLogoOG: `${prosperIconsUrl}/21nebosh-logo.png`,
  neboshLogo: `${prosperIconsUrl}/21nebosh-logo.svg`,
  // Management System Procedures
  UKASManagemntSystemLogoOG: `${prosperIconsUrl}/UKAS-Managemnt-System-logo.png`,
  UKASManagemntSystemLogo: `${prosperIconsUrl}/UKAS-Managemnt-System-logo.svg`,
  // Acreditations
  ifcAccOG: `${prosperIconsUrl}/ifc-acc.png`,
  ifcAcc: `${prosperIconsUrl}/ifc-acc.svg`,
  asfpLogoOG: `${prosperIconsUrl}/asfp-logo.png`,
  asfpLogo: `${prosperIconsUrl}/asfp-logo.svg`,
  firasOG: `${prosperIconsUrl}/firas.webp`,
  firas: `${prosperIconsUrl}/firas.svg`,
  ssipLogoOG: `${prosperIconsUrl}/ssiplogo.png`,
  ssipLogo: `${prosperIconsUrl}/ssiplogo.svg`,

  customerHealthScore: `${prosperIconsUrl}/customer-health-score-white.svg`,

  soaChecked: `${clinkApp}/soa-checked.PNG`,

  sendQuoteBOQ: `${prosperImages}/enquiries.png`,
};
